// -- DELAY TIMINGS -- //

export const AUTH_REFRESH_THRESHOLD = 20000; // time before token.exp to attempt a refresh (20s)
export const AUTH_INACTIVITY_THRESHOLD = 810000; // how long after lastActivity bedfore showing the inactivity modal (13m 30s)
export const AUTH_INACTIVITY_WARNING_TIMEOUT = 60000; // how long to display the inactivity modal before logging out (1m)

// -------------------- || -------------------- //

// -- TESTING VALUES -- //

// set params directly in .yml as follows:
// /var/www/development.console-api.escape-technology.com/app/config/parameters.yml
// jwt_token_ttl: 60
// jwt_refresh_token_ttl: 90

// // SPA values
// export const AUTH_REFRESH_THRESHOLD = 10000; // time before token.exp to attempt a refresh (10s)
// export const AUTH_INACTIVITY_THRESHOLD = 10000; // how long after lastActivity bedfore showing the inactivity modal (10s)
// export const AUTH_INACTIVITY_WARNING_TIMEOUT = 10000; // how long to display the inactivity modal before logging out (10s)

export default {};
